import {Box, Button, Dialog, DialogActions, DialogContent, LinearProgress, Typography} from "@mui/material"
import {translateKey} from "utils/fieldsFormatters";
import { lazy, Suspense, use, useState } from "react";
import {LanguageContext} from "context/LanguageContext";
import {DescriptorInfo, FILES_TYPES, FileType} from "consts/khw-consts";
import {downloadRecord} from "services/khwApi";
import {downloadTextFile} from "utils/downloadTextFile";

const DialogTitleWithCloseAndBackIcon = lazy(() => import("../../common/DialogTitleWithCloseAndBackIcon"));

interface DownloadRecordDialogProps {
    recordJsonData: DescriptorInfo
    open: boolean
    onClose: () => void
}

const DownloadRecordDialog = ({recordJsonData, open, onClose}: DownloadRecordDialogProps) => {
    const {preferredName, nlpId, sourceName} = recordJsonData
    const {language} = use(LanguageContext);
    const fileNamePrefix = preferredName.replace(' ', '_')
    const FIRST_STEP_ACTIONS = ['MARC 21', 'DBN JSON']
    const [selectedFormat, setSelectedFormat] = useState(-1)
    const SELECTED_FORMATS_MAP: { [key: number]: string } = {
        0: 'MARC 21',
        1: 'DBN JSON'
    }

    const downloadFile = (text: string | DescriptorInfo, fileType: FileType) => {
        let dataType = 'text/plain'
        if (fileType === 'JSON') {
            dataType = 'text/json'

            if (typeof text !== "string") { // DBN JSON format
                text = JSON.stringify(text)
            }
        }

        downloadTextFile(text, fileNamePrefix, fileType.toLowerCase(), dataType)

    }


    const onDownloadMARCRecord = (fileType: FileType) => {
        if (fileType === 'MRC') {
            downloadRecord(nlpId, 'MARC', sourceName).then(response => {
                downloadFile(response.data, fileType);

            }).catch(error => console.log(error))
        }else {
            downloadRecord(nlpId, fileType, sourceName).then(response => {
                downloadFile(response.data, fileType);

            }).catch(error => console.log(error))
        }
    }

    const onDownloadDBNRecord = () => {
        downloadFile(recordJsonData, 'JSON')
    }

    const onBack = () => setSelectedFormat(-1)

    return <Dialog open={open} onClose={onClose} fullWidth
                   maxWidth={'sm'}>
        <Suspense fallback={<Box sx={{width: '100%'}}>
            <LinearProgress/>
        </Box>}>
            <DialogTitleWithCloseAndBackIcon title={translateKey('downloadRecord', language)} onClose={onClose}
                                             onBack={onBack} showBackIcon={selectedFormat !== -1}/></Suspense>
        <DialogContent>
            <Typography textAlign={'center'}
                        fontWeight={500}>{selectedFormat === -1 ? translateKey('fileTypeSelectInfo', language) : `${translateKey('selectedFormat', language)} : ${SELECTED_FORMATS_MAP[selectedFormat]}`}</Typography>
        </DialogContent>
        <DialogActions className={'download-dialog-actions'}>
            {selectedFormat === -1 && FIRST_STEP_ACTIONS.map((action, idx) => <Button size={"small"}
                                                                                      key={`format-${idx}`}
                                                                                      variant={idx % 2 ? 'outlined' : 'contained'}
                                                                                      onClick={() => setSelectedFormat(idx)}>{action}</Button>)}
            {selectedFormat === 0 && FILES_TYPES.slice(0, 4).map((fileType, idx) =>
                <Button variant={idx % 2 ? 'outlined' : 'contained'} size={"small"} key={idx}
                        onClick={() => onDownloadMARCRecord(fileType)}>.{fileType.toLowerCase()}</Button>)}
            {selectedFormat === 1 && <Button variant={'contained'} size={"small"}
                                             onClick={() => onDownloadDBNRecord()}>.json</Button>}
        </DialogActions>

    </Dialog>
}

export default DownloadRecordDialog